import React, { useEffect } from 'react';
import { Modal } from '@gerdau/hefesto';
import { InstabilityContent, ModalOverlay } from './styles';

export interface InstabilityModalProps {
  onCloseModal: () => void;
}

export const InstabilityModal = ({ onCloseModal }: InstabilityModalProps) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'visible';
    };
  }, []);

  return (
    <ModalOverlay>
      <Modal
        title="Estamos com instabilidades nos sistemas da Gerdau mais"
        modalSize="sm"
        buttons={{
          right: {
            name: 'button-close-blocked-emitter',
            children: 'Fechar',
            onClick: onCloseModal,
            type: 'button'
          }
        }}
      >
        <InstabilityContent>
          <div>
            Nossa equipe está trabalhando para resolver o problema. Pedimos
            desculpas pelo transtorno e agradecemos a compreensão.
          </div>
        </InstabilityContent>
      </Modal>
    </ModalOverlay>
  );
};
